<form (submit)="submit()" [formGroup]="form">
	<h1 mat-dialog-title>{{'emailInvoicesView .title' | translate}}</h1>
	<mat-dialog-content>
		<div fxLayout="column" fxLayoutAlign="start">
			<app-email-input-with-chips [label]="'emailInvoicesView .emailLabel' | translate" [parentForm]="form"
										[placeholder]="'emailInvoicesView .emailInstructions' | translate">
			</app-email-input-with-chips>
			<mat-form-field>
				<mat-label>{{'emailInvoicesView .subjectLabel' | translate}}</mat-label>
				<input formControlName="subject" matInput required type="text"/>
				<mat-error>{{'emailInvoicesView .subjectRequiredText' | translate}}</mat-error>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{'emailInvoicesView .messageLabel' | translate}}</mat-label>
				<textarea formControlName="message" mat-autosize matInput required></textarea>
				<mat-error>{{'emailInvoicesView .messageLabel' | translate}} is required</mat-error>
			</mat-form-field>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between">
		<button (click)="getInvoice()" [color]="'accent'" fxLayoutAlign="start" mat-raised-button type="button">
			Preview Invoice
		</button>
		<div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="5px">
			<button [color]="'accent'" mat-dialog-close mat-raised-button type="button">
				<span>{{'emailInvoicesView .cancelButton' | translate}}</span>
			</button>
			<button [color]="'primary'" mat-raised-button type="submit">
				{{'emailInvoicesView .sendButton' | translate}}
			</button>
		</div>
	</mat-dialog-actions>
</form>
